import { render, staticRenderFns } from "./btn-text-secondary.vue?vue&type=template&id=2bec3658&scoped=true&"
import script from "./btn-text-secondary.vue?vue&type=script&lang=js&"
export * from "./btn-text-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec3658",
  null
  
)

export default component.exports